module.exports = __webpack_public_path__ + "static/img/situation_2.f09cc9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/situation_2.jpg
// module id = utfH
// module chunks = 1